/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { findListingEntity } from './helpers/entityReadHelpers';
import { upsertListing } from './helpers/entityAdapter';

export const syncProductLive = createAsyncThunk(
  'products/syncProductLive',
  async ({ productId, channelId }) => {
    // TODO: replace this mock sync with BE read through sdk.
    // Expected future flow:
    // await sdk.products.syncLiveListing({ productId, channelId });
    // response should contain refreshed live snapshot from the sales channel.

    await new Promise((resolve) => {
      setTimeout(resolve, 2000);
    });

    return {
      productId,
      channelId,
      syncedAt: Date.now(),
    };
  },
);

export const reducer = (builder) => {
  builder
    .addCase(syncProductLive.pending, (state) => {
      state.error = null;
    })
    .addCase(syncProductLive.fulfilled, (state, { payload }) => {
      const { productId, channelId, syncedAt } = payload;
      const existingListing = findListingEntity(state, { masterProductId: productId, channelId });

      if (!existingListing?._id) return;

      upsertListing(state, {
        ...existingListing,
        masterProductId: productId,
        syncedAt,
      });
    })
    .addCase(syncProductLive.rejected, (state, { error }) => {
      state.error = error?.message || 'Cannot sync live listing';
    });
};
